import { Box, Drawer as MuiDrawer } from '@mui/material';
import { useContext, useEffect } from 'react';
import { Header } from './Header';
import { DrawerContext, DrawerValues } from '../contexts/DrawerContext';
import { DrawerMobileAppBar } from './DrawerMobileAppBar';
import { SlidingSubMenu } from './SlidingSubMenu';
import { LayeredNavGroup } from './LayeredNavGroup';
import { Footer } from './Footer/Footer';
import ActiveOrder from '../../../shared/ActiveOrder';
import { useLocation } from 'react-router-dom';

export const DrawerMain = () => {

  const { appNavItemsToUse, isMobile, open, setOpen, selectedNavItem, slidingSubMenuWidth } = useContext(DrawerContext) as DrawerValues;
  const drawerWidth = 300;
  const location = useLocation();

  useEffect(() => {
    if (isMobile && open) {
      setOpen(false);
    }
  }, [location]);

  return (
    <>
      <DrawerMobileAppBar />
      <MuiDrawer
        variant={isMobile ? 'temporary' : 'permanent'}
        anchor='left'
        open={open}
        ModalProps={{
          hideBackdrop: true,
        }}
        PaperProps={{ sx: { flexDirection: 'row' } }}
        sx={{
          flexShrink: 0,
          width: {
            xs: selectedNavItem
              ? drawerWidth + slidingSubMenuWidth
              : drawerWidth,
          },
          border: 'none',
          boxShadow: 'none',
          '& .MuiPaper-root': {
            borderRadius: {
              xs: '0 25px 25px 0',
              md: '0',
            },
            border: 'none',
            boxShadow: 'none',
            bottom: 0,
            height: '100dvh',
          },
        }}
      >
        <Box
          display='flex'
          flexGrow={1}
          flexDirection='column'
          width={drawerWidth}
          paddingLeft='12px'
          paddingRight='12px'
        >
          <Header />
          <Box
            flexGrow={1}
            flexShrink={1}
            overflow={'auto'}
            sx={{
              scrollbarWidth: 'thin',
              scrollbarColor: 'rgba(0, 0, 0, 0.2) transparent',
            }}>
            <LayeredNavGroup navItemList={appNavItemsToUse} />
          </Box>
          <Box
            sx={{
              position: 'sticky',
              zIndex: 1,
              marginBottom: 6,
            }}
          >
            <ActiveOrder />
          </Box>

          <Footer />
        </Box>
        <SlidingSubMenu />
      </MuiDrawer >
    </>);
};
export default DrawerMain;
